import { call, put } from 'redux-saga/effects';

import BrowserStorage from 'api/utils/browserStorage';
import { removeTokens } from 'api/utils/tokenManagement';

import { resetSubscriptions } from 'store/subscriptions/actions';
import { resetUserData } from 'store/user/actions';
import { closeChatbotSaga } from 'store/user/sagas/openSupportFormSaga';

import { LS_KEYS } from 'helpers/localStorage.ts';

import { setAuthenticationStatus } from '../actions';

export function* logoutSaga() {
    yield call(closeChatbotSaga);
    yield call(removeTokens);
    yield call(BrowserStorage.clearExcept, [LS_KEYS.language]);

    yield put(setAuthenticationStatus(false));
    yield put(resetUserData());
    yield put(resetSubscriptions());
}
